import React, { useState, useEffect } from 'react';
import './LoadingScreen.css';
import BombIcon from './BombIcon';

const LoadingScreen = ({ onLoadingComplete }) => {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [loadingText, setLoadingText] = useState('Initializing...');
  const [showContent, setShowContent] = useState(false);

  const loadingSteps = [
    { progress: 20, text: 'Loading game assets...' },
    { progress: 40, text: 'Connecting to server...' },
    { progress: 60, text: 'Setting up game environment...' },
    { progress: 80, text: 'Preparing multiplayer features...' },
    { progress: 100, text: 'Ready to play!' }
  ];

  useEffect(() => {
    let currentStep = 0;
    const interval = setInterval(() => {
      if (currentStep < loadingSteps.length) {
        const step = loadingSteps[currentStep];
        setLoadingProgress(step.progress);
        setLoadingText(step.text);
        currentStep++;
      } else {
        clearInterval(interval);
        // Add a small delay before showing completion
        setTimeout(() => {
          setShowContent(true);
          // Call the completion callback after animation
          setTimeout(() => {
            onLoadingComplete();
          }, 1000);
        }, 500);
      }
    }, 800);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-screen">
      <div className="loading-background">
        <div className="loading-particles">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="particle" style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`
            }} />
          ))}
        </div>
      </div>
      
      <div className="loading-content">
        <div className="game-logo">
          <div className="logo-icon">
            <div className="bomb-icon">
              <span className="text-6xl">💣</span>
            </div>
          </div>
          <h1 className="game-title">Bomberman Hunt</h1>
          <p className="game-subtitle">Multiplayer Battle Arena</p>
        </div>

        <div className="loading-progress-container">
          <div className="loading-progress-bar">
            <div 
              className="loading-progress-fill"
              style={{ width: `${loadingProgress}%` }}
            />
          </div>
          <div className="loading-progress-text">{loadingText}</div>
          <div className="loading-percentage">{loadingProgress}%</div>
        </div>

        {showContent && (
          <div className="loading-complete">
            <div className="success-icon">✓</div>
            <p>Welcome to Bomberman Hunt!</p>
          </div>
        )}
      </div>

      <div className="loading-footer">
        <p>© 2024 Bomberman Hunt. All rights reserved.</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
